import React, { useState } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import PropTypes from 'prop-types';
import EditForm from './EditForm.jsx';
import Login from './LoginScreen.jsx';
import Search from './SearchScreen.jsx';
import { Screens, FlowSteps } from '../../state';
import { NeuroMessage } from '../../../components';
import Scrollbar from '../../../components/Scrollbar';

const Container = ({
  flowSteps,
  initialScreen,
  loginFlowChanged,
  onEmployeeSelected,
  processing,
  selectedEmployee,
  ...rest
}) => {
  const getInitialScreen = () => {
    let screen = Screens.SEARCH;
    if (selectedEmployee && selectedEmployee.id) {
      screen =
        selectedEmployee.branches && selectedEmployee.branches.length > 0
          ? Screens.LOGIN
          : Screens.EDIT;
    }
    return screen;
  };

  const cssBEM = 'employee-login-container';
  const [selectedScreen, setSelectedScreen] = useState(
    initialScreen || getInitialScreen()
  );

  const changeScreen = (changeToScreen) => {
    setSelectedScreen(changeToScreen);
  };
  const cancelButtonClicked = () => {
    setSelectedScreen(Screens.SEARCH);
    onEmployeeSelected({});
    loginFlowChanged(null, null, true);
  };

  const renderFlowStep = (step, number) => {
    const isComplete = flowSteps[step];
    const icon = isComplete ? (
      <i className="fa fa-check-circle" />
    ) : (
      <i className="flow-step-number">{number}</i>
    );
    return (
      <span>
        {icon} <NeuroMessage id={`employeeLogin.flowStep.${step}`} />
      </span>
    );
  };

  let ViewComponent = Search;
  switch (selectedScreen) {
    case Screens.EDIT:
      ViewComponent = EditForm;
      break;
    case Screens.LOGIN:
      ViewComponent = Login;
      break;
    default:
      break;
  }

  // noinspection RequiredAttributes
  return (
    <div className={cssBEM}>
      <NeuroMessage id="employeeLogin.title" tagName="h5" />
      <div className={`${cssBEM}__details`}>
        <TransitionGroup className="details-text-container">
          <CSSTransition
            key={selectedScreen}
            classNames="details-text"
            timeout={2000}
          >
            <div className="details-text">
              <NeuroMessage id={`employeeLogin.${selectedScreen}.header`} tagName="h1"/>
              <NeuroMessage id={`employeeLogin.${selectedScreen}.subtitle`} tagName="span"/>
            </div>
          </CSSTransition>
        </TransitionGroup>
        <div className="details-footer">
          {renderFlowStep(FlowSteps.PROFILE_SELECTED, 1)}
          {renderFlowStep(FlowSteps.BRANCH_SELECTED, 2)}
          {renderFlowStep(FlowSteps.LOGGED_IN, 3)}
        </div>
      </div>
      <div className={`${cssBEM}__content`}>
        {processing ? (
          <i className="fa fa-circle-o-notch fa-spin processing-icon" />
        ) : null}
        <Scrollbar>
          <div className={`${cssBEM}__component`}>
            <ViewComponent
              {...rest}
              changeScreen={changeScreen}
              loginFlowChanged={loginFlowChanged}
              onCancel={cancelButtonClicked}
              onEmployeeSelected={onEmployeeSelected}
              processing={processing}
              selectedEmployee={selectedEmployee}
            />
          </div>
        </Scrollbar>
      </div>
    </div>
  );
};

Container.propTypes = {
  initialScreen: PropTypes.string,
  flowSteps: PropTypes.object.isRequired,
  loginFlowChanged: PropTypes.func.isRequired,
  processing: PropTypes.bool,
  onEmployeeSelected: PropTypes.func.isRequired,
  selectedEmployee: PropTypes.object,
};

export default Container;
